module.exports = __webpack_public_path__ + "img/person-disabled.b1db6135.svg";